import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
	@import url(${variables.fontHeadlineUrl});
	position: relative;
	height: 80vh;
	max-height: 50em;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	width: 100%;
	background-position-x: center;
	background-position-y: 5em;
	background-repeat: no-repeat;
	background-size: cover;

	.copy {
		transform: translate(0, 25%);
		color: #000000;
		max-width: 57em;
		position: relative;
		z-index: 9;
		line-height: normal;
		font-size: inherit;

		.headline-wrapper {
			display: inline-block;

			.headline,
			.subheadline {
				font-family: ${variables.fontHeadline};
				font-size: 2.45em;
				font-weight: 700;
				padding: 0em 0.9em 0.195em;
				background-position: 0 50%;
				background-repeat: no-repeat;
				background-size: 100%;
			}
			.headline {
				/* padding: 0em 5.2em 0.195em 0.9em; */
				padding: 0em 2.2em 0.195em 0.9em;
				background-size: 140%;
				border-radius: 0em 10em 40em 0;
				background-position: 0% 33%;
			}
		}
	}

	.info-headline-wrappper {
		position: absolute;
		bottom: 10em;
		z-index: 9;
		left: 50%;
		transform: translateX(-50%);

		.infoheadline {
			color: #fff;
			font-weight: 600;
		}
	}

	@media all and (max-width: ${variables.desktopS}) {
		background-position-x: center;
		background-position-y: 5em;
	}

	@media all and (max-width: ${variables.tabletL}) {
		.copy {
			.headline-wrapper {
				margin-bottom: 0.5em;

				.headline,
				.subheadline {
					font-size: 2.1em;
				}
			}
		}
	}

	@media all and (max-width: ${variables.tabletS}) {
		.copy {
			.headline-wrapper {
				.headline,
				.subheadline {
					font-size: 1.8em;
				}
			}
		}
	}

	@media all and (max-width: ${variables.mobileL}) {
		.copy {
			.headline-wrapper {
				.headline,
				.subheadline {
					font-size: 1.45em;
				}
			}
		}
	}
`;
